/*
 * @Author: Jing
 * @Date: 2021-12-20 15:05:13
 * @Descripttion:
 */
import noPic from '@/assets/image/no_pic.jpg'
import avatarUn from '@/assets/image/avatar_unknown.png'
import avatarUnMan from '@/assets/image/avatar_doctor_man.png'
import avatarUnWoman from '@/assets/image/avatar_doctor_woman.png'
import avatarGirl from '@/assets/image/avatar_kids_girl.png'
import avatarBoy from '@/assets/image/avatar_kids.png'
import avatarMan from '@/assets/image/avatar_man.png'
import avatarWoman from '@/assets/image/avatar_wowan.png'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Shanghai')

export function fill0(num: number): string {
    return num < 10 ? '0' + num : num + ''
}
export function formatTime(d: any) {
    if (d instanceof Date) {
        let hour = d.getHours()
        let hours: string = hour < 10 ? '0' + hour : hour.toString()
        let min = d.getMinutes()
        let mins: string = min < 10 ? '0' + min : min.toString()
        return hours + ':' + mins
    }
    return ''
}
export function tsToDate(value: any) {
    if (value instanceof Date) {
        return value
    } else {
        if (value === 0) {
            value = Number(value)
            return new Date(value)
        }
        if (!value) {
            return null
        }
        value = Number(value)
        return new Date(value)
    }
}
export function formatDate(date: any) {
    return formatDataBy(date, '-')
}
export function formatDataBy(date: any, div: string) {
    if (date instanceof Date) {
        let m = date.getMonth() + 1
        let mStr = fill0(m)

        let d = date.getDate()
        let dStr = fill0(d)

        var y = date.getFullYear()

        return y + div + mStr + div + dStr
    }
    return ''
}
// 图片回显处理
export function formatSrc(url: string) {
    if (!url) return noPic
    let host = window.location.origin + '/'
    if (url.startsWith('http')) {
        return url
    } else {
        return host + url
    }
}

class Filters {
    IMG_SRC(value: string) {
        let domain = '/'
        if (!value || value.indexOf('\\') > 0) {
            // return '/assets/no_pic.jpeg'
            return noPic
        }
        if (value.indexOf('/') === 0) {
            return value
        }
        let src = value.startsWith('http') ? value : domain + value
        return src
    }
    IMG_AVATAR(user: any) {
        let url = user.headUrl || user.userHeadUrl
        if (url && url.startsWith('http')) return url
        if (url) {
            return '/' + url
        }
        if (!user || !user.birthdayDate || !user.userSex) {
            return avatarUn
        }
        let now = dayjs.tz(new Date().setHours(0, 0, 0, 0))
        let year = now.diff(user.birthdayDate, 'year')
        if (user.userSex != 1 && user.userSex != 2) {
            return avatarUn
        }
        if (year < 14) {
            if (user.userSex == 1) {
                return avatarBoy
            } else {
                return avatarGirl
            }
        }

        if (user.userSex == 1) {
            return avatarMan
        }
        if (user.userSex == 2) {
            return avatarWoman
        }
    }
    TS_TIME(value: any) {
        var d = tsToDate(value)
        return formatTime(d)
    }
    DATE(value: any) {
        var d = tsToDate(value)
        return formatDate(d)
    }
    DATE_TIME(value: any) {
        if (!value) return ''
        var d = tsToDate(value)
        return formatDate(d) + ' ' + formatTime(d)
    }
    TIME_TYPE(value: string, type = 'YYYY-MM-DD') {
        return dayjs.tz(value).format(type)
    }
    LEVLE(val: any) {
        switch (Number(val)) {
            case 0:
                return ''
                break
            case 1:
                return 'A'
                break
            case 2:
                return 'B'
                break
            case 3:
                return 'C'
                break
            case 4:
                return 'D'
                break
            case 5:
                return 'E'
                break
            default:
                break
        }
    }
    AVATAR_SRC(value: any, sex?: number) {
        if (value && value.startsWith('http')) return value
        const first = value ? value.slice(0, 1) : ''
        if (!value || value.indexOf('\\') > 0) {
            // 2为女性 其他情况为男性或未知
            if (sex == 2) {
                return avatarUnWoman
            } else {
                return avatarUnMan
            }
        }
        return first == '/' ? value : '/' + value
    }
    AGE(value: any) {
        var startDate = new Date(value)
        var endDate = new Date()
        var day = 0
        var month = 0
        if (endDate.getDate() >= startDate.getDate()) {
            day = endDate.getDate() - startDate.getDate()
        } else {
            day += endDate.getDate()
            endDate.setDate(0)
            day += endDate.getDate() - startDate.getDate()
        }
        var year = endDate.getFullYear() - startDate.getFullYear()
        var month = endDate.getMonth() - startDate.getMonth()
        if (month < 0) {
            month += 12
            year -= 1
        }
        if (year > 14) {
            return year + '岁'
        } else if (year >= 1) {
            return year + '岁' + month + '个月'
        } else if (month >= 1) {
            return month + '个月'
        } else {
            return day + '天'
        }
    }
    SEX(value: any) {
        if (value == '1') return '男'
        if (value == '2') return '女'
        return '未知'
    }
    DATE_MM_DD(value: any) {
        var d = Number(value)
        var result = dayjs.tz(d).format('MM-DD').split('-')
        return `${Number(result[0])}月${result[1]}日`
    }
    TIME_SLOT(value: any) {
        if (!value) return ''
        if (value == 1) return '上午'
        if (value == 2) return '下午'
        if (value == 3) return '晚上'
        return '未知'
    }
    APPOINTMENT_TIME(item: any, num: boolean, time: boolean) {
        if (item.serialNumber) {
            // 新预约时间显示
            let subLabel = ''
            let startTime = item.exactTime
            let endTime = item.endTime
            let timeText = ''
            if (startTime) {
                timeText = dayjs.tz(Number(item.exactTime)).format('HH:mm')
            }
            switch (item.timeSlot) {
                case 1:
                    subLabel = item.serialNumber ? `上午${item.serialNumber % 1000}号 ` : ''
                    break
                case 2:
                    subLabel = item.serialNumber ? `下午${item.serialNumber % 2000}号 ` : ''
                    break
                case 3:
                    subLabel = item.serialNumber ? `晚上${item.serialNumber % 3000}号 ` : ''
                    break
                default:
                    return ''
            }
            if (num) {
                return subLabel
            }
            if (time) {
                return timeText
            }
            if (num && time) {
                return subLabel + timeText
            }
        }
    }
    BOOK_STAT(value: any) {
        // 1、已预约 2、已就诊 3、已取消）患者） 4、已取消（诊所） 5、已取消（医生坐诊）
        if (value == 9) return '失  约'
        if (value == 1) return '预约成功'
        if (value == 2) return '已就诊'
        if (value == 3) return '已取消'
        if (value == 4) return '已取消'
        if (value == 5) return '已取消'
    }
    CHECK_RESULT_REF(value: string, item: any) {
        let map = {
            '-_2': '无(-)',
            '-_1': '阴(-)',
            '+_1': '阳(+)',
            '+_2': '有(+)',
            '++_2': '多(++)',
            '+++_2': '大量(+++)',
            '±_1': '弱阳性',
        }
        if (!value) {
            return ''
        }
        if (!value.includes("_")) {
            value = value + "_" + item.maxValue;
        }
        if (map[value]) {
            return map[value];
        }
        return "未知";
    }
    CHECK_REFERS_OUT(row: any) {
        if (row.checkType == 3 || row.checkType == 4) {
            return row.minValue
        }
        if (row.checkType == 5 || row.checkType == 6) {
            if (row.minValue || row.maxValue) {
                return (row.minValue ? row.minValue : '') + (row.maxValue ? row.maxValue : '')
            }
            if (row.minValue && row.maxValue) {
                return row.minValue + '~' + row.maxValue
            }
        }
    }
    PROP(property: any) {
        if (property == 0) {
            return ''
        } else if (property == 1) {
            return '异常'
        } else if (property == 2 || property == '↑') {
            return '高'
        } else if (property == 3 || property == '↓') {
            return '低'
        } else if (isNaN(Number(property))) {
            return property
        } else {
            return ''
        }
    }
    CNY(value: any) {
        if (!value) return 0
        return (parseInt(value) / 10000).toFixed(2)
    }
    SUBJECT_TYPE(val: number) {
        switch (val) {
            case 1:
                return '普通挂号费'
            case 2:
                return '急诊诊疗费'
            case 3:
                return '检验费'
            case 5:
                return '诊疗费'
            case 10:
                return '治疗费'
            case 12:
                return '耗材费'
            case 6:
                return '检查费'
            case 15:
                return '西药费'
            case 16:
                return '中成药费'
            case 20:
                return '中草药费'
            case 25:
                return '代煎费'
            case 30:
                return '其他收费'
            case 31:
                return '检查费'
            case 35:
                return '器械费'
            case 41:
                return '科室体检费'
            case 42:
                return '体检检验费'
            case 43:
                return '体检检查费'
            case 51:
                return '预约费'
            case 61:
                return '自定义1'
            case 62:
                return '自定义2'
            case 63:
                return '自定义3'
            case 64:
                return '自定义4'
            case 65:
                return '自定义5'
            default:
                return '其他收费'
        }
    }

    SUB(value: string, len: number) {
        if (!value) return ''
        len = -Number(len)
        return value.substr(len)
    }

    MEMBER_LEVEL(num: any) {
        if (!num) return '一'
        let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'] // changeNum[0] = "零"
        let unit = ['', '十', '百', '千', '万']
        num = parseInt(num)
        let getWan = (temp: any) => {
            let strArr = temp.toString().split('').reverse()
            let newNum = ''
            for (var i = 0; i < strArr.length; i++) {
                newNum = (i == 0 && strArr[i] == 0 ? '' : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? '' : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) + newNum
            }
            return newNum
        }
        let overWan = Math.floor(num / 10000)
        let noWan: any = num % 10000
        if (noWan.toString().length < 4) noWan = '0' + noWan
        return overWan ? getWan(overWan) + '万' + getWan(noWan) : getWan(num)
    }

    INFO(val: any) {
        switch (Number(val)) {
            case 0:
                return '请按时前来就诊，如有疑问请咨询诊所医护人员'
            default:
                return '— 详细信息请登录诊所系统查看 —'
        }
    }

    tsToDate(value: any) {
        if (value instanceof Date) {
            return value
        } else {
            if (value === 0) {
                value = Number(value)
                return new Date(value)
            }
            if (!value) {
                return null
            }
            value = Number(value)
            return new Date(value)
        }
    }
}

export default new Filters()
